import { useEffectOnce } from './useEffectOnce';
import { NavOnboardingTourError } from '../errors/NavOnboardingTourError';
import { startTour as startTourRequest } from '../communication/startTour';
import { useCallback, useEffect, useState } from 'react';
import { LOGGER_NAME, setupLogger } from '../logging/setupLogger';
import { Logger } from 'simple-logging-lib';
export const useStartOnboardingTour = tour => {
  const [retryCount, setRetryCount] = useState(0);
  const [showTourSuccess, setShowTourSuccess] = useState(false);
  const showTour = useCallback(() => {
    const logger = Logger.getLogger(LOGGER_NAME);
    try {
      logger.debug(`Starting onboarding tour: ${tour.tourId}`);
      startTourRequest(tour, () => {
        logger.debug(`Onboarding tour started successfully: ${tour.tourId}`);
        setShowTourSuccess(true);
      });
    } catch (error) {
      throw new NavOnboardingTourError('Error showing onboarding tour', {
        cause: error
      });
    }
    setRetryCount(prevCount => prevCount + 1);
  }, [tour]);
  useEffectOnce(() => {
    setupLogger();
  });
  useEffect(() => {
    if (showTourSuccess) {
      return;
    }
    let intervalId;
    if (retryCount < 4) {
      intervalId = setInterval(showTour, 250);
    }
    if (retryCount >= 4) {
      throw new NavOnboardingTourError('Failed to start onboarding tour, retries exhausted');
    }
    return () => {
      clearInterval(intervalId);
    };
  }, [showTour, retryCount, showTourSuccess]);
};